import { DashboardModule } from '@domain-group/suit-theme'
import { useFilters } from '@domain-group/react-hooks'
import useProviderPriceLists from '@hooks/useProviderPriceLists'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import ProviderPriceList from './ProviderPriceList'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'agency_string',
      label: 'Agency Title or ID',
    },
  ]
}

interface ForkedPriceListsProps {
  providerPriceListId: number,
}

const ForkedPriceLists = (props: ForkedPriceListsProps) => {
  const { providerPriceListId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const forkedPriceListsPayload = useProviderPriceLists({
    filters: {
      ...pageFilters,
      master_price_list_id: providerPriceListId,
    },
    performHttpRequests: !!providerPriceListId,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviderPriceLists,
    filteredProviderPriceListsCount,
    hasFilteredProviderPriceLists,
    loading,
  } = forkedPriceListsPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Forked Price Lists"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && hasFilteredProviderPriceLists && (
        <DashboardModule.ScrollableSection>
          {filteredProviderPriceLists.map(providerPriceList => (
            <ProviderPriceList
              key={providerPriceList.id}
              providerPriceList={providerPriceList}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredProviderPriceLists && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Forked Price Lists Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Forked Price Lists will appear here when a Price List forked from this one.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredProviderPriceListsCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default ForkedPriceLists
